export default "__VITE_ASSET__BPgGyJY2__"